import type { TFunction } from "i18next";
import type { UrlObject } from "url";

import { Routes } from "@/shared/constants/Routing";

export type NavbarItem = {
    label: string;
    description?: string;
    url?: string | UrlObject;
    as?: string;
    menuLayout?: "two-column" | "three-column";
    items?: NavbarItem[];
};

/** Desktop/mobile nav — плоский паттерн как у product-лендингов. */
export const getNavbarItems = (t: TFunction): NavbarItem[] => [
    { label: t("settings.navbar.tariffs"), url: Routes.TARIFFS },
    { label: t("settings.navbar.cases"), url: Routes.PORTFOLIO },
    { label: t("settings.navbar.games"), url: Routes.GAMES },
    { label: t("settings.navbar.blog"), url: Routes.ARTICLES },
    { label: t("settings.navbar.about"), url: Routes.ABOUTUS },
    {
        label: t("settings.navbar.solutions"),
        menuLayout: "two-column",
        items: [
            { label: t("settings.navbar.allIndustries"), url: Routes.SOLUTIONS },
            { label: t("settings.navbar.knowledge"), url: Routes.KNOWLEDGE },
            { label: t("settings.navbar.horeca"), url: "/solutions/horeca" },
            { label: t("settings.navbar.beauty"), url: "/solutions/beauty" },
            { label: t("settings.navbar.retail"), url: "/solutions/retail" },
            { label: t("settings.navbar.fitness"), url: "/solutions/fitness" },
            { label: t("settings.navbar.servicesNiche"), url: "/solutions/services" },
            { label: t("settings.navbar.realty"), url: "/solutions/realty" },
            { label: t("settings.navbar.autoSales"), url: "/solutions/auto-sales" },
            { label: t("settings.navbar.autoService"), url: "/solutions/auto-service" },
        ],
    },
];
